import type { FAQItem } from "~/v2/components/common/FAQ";

export const ASSETS_HOLDING_FAQ: FAQItem[] = [
  {
    question: "What types of assets can I transfer to Alpaca?",
    answer: (
      <>
        US stocks, ETFs, cash balances, and margin balances (for eligible
        accounts).
      </>
    ),
  },
];
